
export const baseAPIUrl =
  window.location.protocol + "//" + window.location.host.replace("3001","3000")+"/";


console.log("The host url is... ", baseAPIUrl);
